<template>
  <div>
    <el-input-number
      size="small"
      v-model="startNum"
      :controls="false"
      placeholder="请输入最小数值"
      :min="info.detectionRangeMin"
      @blur="updateRange('startNum')"
      :max="info.detectionRangeMax"
    ></el-input-number
    >-
    <el-input-number
      size="small"
      v-model="endNum"
      @blur="updateRange('endNum')"
      :controls="false"
      placeholder="请输入最大数值"
      :min="info.detectionRangeMin"
      :max="info.detectionRangeMax"
    ></el-input-number>
  </div>
</template>

<script>
import { isNumber } from "mathjs";
export default {
  data() {
    return {
      startNum: null,
      endNum: null,
    };
  },
  props: ["info", "index"],
  watch: {
    'info.fieIdValue': {
			handler(newValue) {
				if(newValue !== undefined && newValue !== null) {
				    this.startNum = newValue
				} else {
				    this.startNum = this.info.defaultValue
				}
				this.updateRange('startNum')
			},
			immediate: true,
		},
		'info.fieldValueRange': {
			handler(newValue) {
				if(newValue !== undefined && newValue !== null) {
				    this.endNum = newValue
				} else {
				    this.endNum = this.info.defaultValueRange
				}
				this.updateRange('endNum')
			},
			immediate: true,
		},
  },
  methods: {
    updateRange(type) {
      if (type == "startNum") {
        let obj = {
          type: 1,
          fieIdId: this.info.fieIdId,
          fieIdValue: this.startNum,
          fieldValueRange: this.endNum,
          index: this.index,
        };
        if (
          Number(this.startNum) < Number(this.info.detectionRangeMin) ||
          Number(this.startNum) > Number(this.info.detectionRangeMax)
        ) {
          this.startNum = this.info.detectionRangeMin;
          obj.fieIdValue = this.info.detectionRangeMin;
          this.$forceUpdate();
        }
        if (this.endNum) {
          if (Number(this.startNum > this.endNum)) {
            this.startNum = this.info.detectionRangeMin;
            obj.fieIdValue = this.info.detectionRangeMin;
            this.$forceUpdate();
          }
        }
        //如果最大值和最小值都有值则进行计算，没有就给值赋0
        if (isNumber(Number(this.startNum)) && isNumber(Number(this.endNum))) {
          let value = Number(this.endNum) - Number(this.startNum);
          if (value > 0) {
            obj.value = value;
          } else {
            obj.value = 0;
          }
        } else {
          obj.value = 0;
        }
        this.$emit("updateRange", obj);
      } else {
        let obj = {
          type: 2,
          fieIdId: this.info.fieIdId,
          fieIdValue: this.startNum,
          fieldValueRange: this.endNum,
          index: this.index,
        };
        if (
          Number(this.endNum) > Number(this.info.detectionRangeMax) ||
          Number(this.endNum) < Number(this.info.detectionRangeMin)
        ) {
          this.endNum = this.info.detectionRangeMax;
          obj.fieldValueRange = this.info.detectionRangeMax;
          this.$forceUpdate();
        }
        if (this.startNum) {
          if (Number(this.startNum > this.endNum)) {
            this.endNum = this.info.detectionRangeMax;
            obj.fieldValueRange = this.info.detectionRangeMax;
            this.$forceUpdate();
          }
        }
        //如果最大值和最小值都有值则进行计算，没有就给值赋0
        if (isNumber(Number(this.startNum)) && isNumber(Number(this.endNum))) {
          let value = Number(this.endNum) - Number(this.startNum);
          if (value > 0) {
            obj.value = value;
          } else {
            obj.value = 0;
          }
        } else {
          obj.value = 0;
        }
        this.$emit("updateRange", obj);
      }
    },
  },
};
</script>